import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { UpdateData } from '@records/state/current-data/update-data.action';
import { ExecutableAction } from '../utils/executable-action';
import { ClearCurrentData } from './clear-current-data.action';
import { CurrentDataModel } from './current-data.model';
import { GetRecord } from './get-record.action';
import { AddPropertyTypesAction } from './property/add-property-types.action';
import { UpdateDuplicateSpace } from './update-duplicate-space.action';
export { CurrentDataModel } from './current-data.model';
@State<CurrentDataModel>({
  name: 'currentData',
  defaults: {
    recordLoaded: false,
    usagesInfo: null,
    record: null,
    oldRecord: null,
    duplicatedSpaces: null,
  },
})
@Injectable()
export class CurrentDataState {
  private readonly store = inject(Store);
  @Selector()
  static record(state: CurrentDataModel) {
    return state.record;
  }
  @Selector()
  static oldRecord(state: CurrentDataModel) {
    return state.oldRecord;
  }
  @Selector()
  static getState(state: CurrentDataModel): CurrentDataModel {
    return state;
  }
  @Action(ClearCurrentData)
  @Action(GetRecord)
  @Action(UpdateData)
  @Action(UpdateDuplicateSpace)
  @Action(AddPropertyTypesAction)
  public executeAction(ctx: StateContext<CurrentDataModel>, params: ExecutableAction<CurrentDataModel>) {
    return params.execute({ ctx, store: this.store });
  }
}
